import { ControlEventType } from '../../controls/enums';

export const FormControlState = {
  Value: 'value',
  Error: 'error',
  IsValid: 'isValid',
  IsDisabled: 'isDisabled',
  ValidationStrategy: 'validationStrategy',
} as const;

export const FormGroupState = {
  Controls: 'controls',
  Error: 'error',
  IsDisabled: 'isDisabled',
} as const;

export const FormControlValidationStrategy = {
  ...ControlEventType,
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type FormControlValidationStrategy = typeof FormControlValidationStrategy[
  keyof typeof FormControlValidationStrategy
];
